import { render, staticRenderFns } from "./meal-detail.vue?vue&type=template&id=60ff4df2&scoped=true&"
import script from "./meal-detail.vue?vue&type=script&lang=js&"
export * from "./meal-detail.vue?vue&type=script&lang=js&"
import style0 from "./meal-detail.vue?vue&type=style&index=0&id=60ff4df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff4df2",
  null
  
)

export default component.exports